/**
 * Concept van de toetswizard in sessionStorage (15-10-2026).
 *
 * Tot nu toe was de sleutel alleen `tw-concept-<mode>`, zonder docent. Wie in
 * hetzelfde tabblad uitlogde en als een andere docent inlogde (testaccounts,
 * een gedeelde lespc), kreeg het concept van de vorige docent te zien: een
 * wiskunde- en geschiedenisdocent opende het Engelse woordjesconcept (Yasar).
 * Nu hoort de sleutel bij de ingelogde gebruiker, en bij uitloggen of wisselen
 * van account gaan alle concepten en klaargezette startvragen weg.
 */
import { START_VRAGEN_KEY } from './vraagDbNaarWizard';

const VOORVOEGSEL = 'tw-concept-';

export function conceptSleutel(mode, gebruikerId) {
  return `${VOORVOEGSEL}${mode}-${gebruikerId || 'onbekend'}`;
}

/** Oude sleutels zonder gebruiker (vóór 15-10-2026) weghalen. */
export function wisOudeConcepten(opslag = window.sessionStorage) {
  try {
    ['toets', 'communicatie'].forEach((m) => opslag.removeItem(`${VOORVOEGSEL}${m}`));
  } catch { /* opslag geblokkeerd */ }
}

/** Alle wizardconcepten en startvragen weg (bij uitloggen of ander account). */
export function wisAlleConcepten(opslag = window.sessionStorage) {
  try {
    const weg = [];
    for (let i = 0; i < opslag.length; i++) {
      const k = opslag.key(i);
      if (k && (k.startsWith(VOORVOEGSEL) || k === START_VRAGEN_KEY)) weg.push(k);
    }
    weg.forEach((k) => opslag.removeItem(k));
  } catch { /* opslag geblokkeerd */ }
}
